<app-page-shell variant="default">
<!--    <div class="row">-->
    <!--      <div class="col-xl-3 col-md-3 col-sm-3">-->
    <!--        <div class="card card-box card-box-border-bottom border-info text-left mb-5 p-4">-->
    <!--          <div class="d-flex align-items-center">-->
    <!--            <div class="d-70 rounded-circle bg-neutral-first text-white mr-3 text-center">-->
    <!--              <li class="fa fa-users" style="font-size: 2rem; color: #4ab8e3; margin-top: 1.2rem;"></li>-->
    <!--            </div>-->
    <!--            <div class="flex-grow-1">-->
    <!--              <div class="font-size-xxl font-weight-bold">{{totalInfluencers}}</div>-->
    <!--              <div class="text-black-50 pb-1 font-weight-bold">influencers</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="col-xl-3 col-md-3 col-sm-3">-->
    <!--        <div class="card card-box card-box-border-bottom border-info text-left mb-5 p-4">-->
    <!--          <div class="d-flex align-items-center">-->
    <!--            <div class="d-70 rounded-circle bg-neutral-first text-white mr-3 text-center">-->
    <!--              <li class="fa fa-line-chart" style="font-size: 2rem; color: #4ab8e3; margin-top: 1.2rem;"></li>-->
    <!--            </div>-->
    <!--            <div class="flex-grow-1">-->
    <!--              <div class="font-size-xxl font-weight-bold ">{{totalPageViews}}</div>-->
    <!--              <div class="text-black-50 pb-1 font-weight-bold">page views</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="col-xl-3 col-md-3 col-sm-3">-->
    <!--        <div class="card card-box card-box-border-bottom border-info text-left mb-5 p-4">-->
    <!--          <div class="d-flex align-items-center">-->
    <!--            <div class="d-70 rounded-circle bg-neutral-first text-white mr-3 text-center">-->
    <!--              <li class="fa fa-share" style="font-size: 2rem; color: #4ab8e3; margin-top: 1.2rem;"></li>-->
    <!--            </div>-->
    <!--            <div class="flex-grow-1">-->
    <!--              <div class="font-size-xxl font-weight-bold ">{{totalShares}}</div>-->
    <!--              <div class="text-black-50 pb-1 font-weight-bold">shares</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="col-xl-3 col-md-3 col-sm-3">-->
    <!--        <div class="card card-box card-box-border-bottom border-info text-left mb-5 p-4">-->
    <!--          <div class="d-flex align-items-center">-->
    <!--            <div class="d-70 rounded-circle bg-neutral-first text-first mr-3 text-center">-->
    <!--              <li class="fa fa-dollar" style="font-size: 2rem; color: #4ab8e3; margin-top: 1.2rem;"></li>-->
    <!--            </div>-->
    <!--            <div class="flex-grow-1">-->
    <!--              <div class="font-size-xxl font-weight-bold ">{{totalReferrals}}</div>-->
    <!--              <div class="text-black-50 pb-1 font-weight-bold">conversions</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div *ngIf="errorMessage?.length" class="show-error">
      <h2>{{errorMessage}}</h2>
    </div>
    <div [hidden]="!allProjectList?.length && !isOnLoad"
         class="test-{{allProjectList?.length}} card card-box mb-5 my-project border-0 shadow-none">
      <div class="page-header header">
        <div class="page-header__title">
          <h2 class="mb-0 title">My Snöballed Projects</h2>
        </div>
        <div class="page-header__actions start-project" *ngIf="currentUser?.can('create-project', 'project-ui')">
          <a class="btn btn-sm btn-primary pull-right"
             routerLink="/{{routes.createProject()}}" sbEntityLink role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Start Project</span>
          </a>
        </div>
      </div>
      <div class="project-toolbar project-name-dropdown">
        <div class="project-toolbar__selects client-dropdown-position">
          <div class="client-dropdown" *ngIf="currentUser?.can( 'view-client-column', 'project-ui')">
            <app-auto-complete-select
              [hideLabel]="true"
              [isCreatable]="false"
              [onlyBottomBorder]="false"
              [placeholder]="'Select Client'"
              [selectOptions]="planners"
              [selectedValue]="selectedClient !== 'All' ? selectedClient : null"
              (optionSelected)="projectList($event)"
              (searchValue)="handleSearchValue($event)"
              (scrollToEnd)="handleScroll()"
            ></app-auto-complete-select>
          </div>
          <div class="client-dropdown" *ngIf="currentUser?.can('filter-by-organization', 'project-ui')">
            <app-auto-complete-select
              [hideLabel]="true"
              [isCreatable]="false"
              [onlyBottomBorder]="false"
              [placeholder]="'Select Organization'"
              [selectOptions]="organizations"
              [selectedValue]="selectedOrganization !== 'All' ? selectedOrganization : null"
              (optionSelected)="onOrganizationSelected($event)"
            ></app-auto-complete-select>
          </div>
        </div>
        <div class="project-toolbar__controls customize-email">
          <label class="project-toolbar__stats" for="customize_columns">
            <input id="customize_columns" placeholder="" [checked]="showAll" (change)="showAllColumns($event)"
                   type="checkbox">
            <span>Display Project Stats</span>
          </label>
          <div class="project-toolbar__status" role="group" aria-label="Project status">
            <a class="filters" [ngClass]="{'active-status': selectedStatus === 'all'}" (click)="onChangeProjectStatus('all')">
              All
            </a>
            <a class="filters" [ngClass]="{'active-status': selectedStatus === 'active'}" (click)="onChangeProjectStatus('active')">
              Active
            </a>
            <a class="filters" [ngClass]="{'active-status': selectedStatus === 'draft'}" (click)="onChangeProjectStatus('draft')">
              Draft
            </a>
            <a class="filter-last" [ngClass]="{'active-status': selectedStatus === 'completed'}" (click)="onChangeProjectStatus('completed')">
              Completed
            </a>
          </div>
          <div class="project-toolbar__view" role="group" aria-label="View type">
            <button type="button" [ngClass]="{'active-btn': viewType === 'card', 'inactive-btn': viewType !== 'card'}" class="btn btn-default btn-sm list-button" (click)="changeViewType('card')">
              <i class="fa fa-th-large mr-1"></i>
              Card
            </button>
            <button type="button" [ngClass]="{'active-btn': viewType === 'list', 'inactive-btn': viewType !== 'list'}" class="btn btn-default btn-sm card-button" (click)="changeViewType('list')">
              <i class="fa fa-th-list mr-1"></i>
              List
            </button>
          </div>
        </div>
      </div>

      <div class="custom-table px-0" [ngClass]="{'project-list-table pt-0': viewType === 'card'}">
        <table width="100%" class="sb-table table dataTable no-footer nowrap" datatable
               [dtTrigger]="dtTrigger"
               [dtOptions]="dtOptions"
               id="dt-table">
          <thead>
          <tr [ngClass]="{'d-none': viewType !== 'list'}">
            <th class="no-sort project-image"></th>
            <th><span>NAME</span></th>
            <th class="no-sort">CAMPAIGNS</th>
            <th class="no-sort" [ngClass]="{'d-none': !showAll}">INFLUENCERS</th>
            <th class="no-sort" [ngClass]="{'d-none': !showAll}">OPEN/CLICK RATE</th>
            <th class="no-sort" [ngClass]="{'d-none': !showAll}">IMPRESSIONS</th>
            <th class="no-sort" [ngClass]="{'d-none': !showAll}">CONVERSIONS</th>
            <th class="no-sort d-none">CREATED DATE</th>
            <th class="no-sort"></th>
          </tr>
          </thead>
          <tbody *ngIf="!(loader$ | async) && projects?.length > 0">
          <ng-container *ngIf="viewType === 'list'">
            <tr *ngFor="let project of projects">
              <td class="cursor-pointer">
                <img class="image-thumbnail" *ngIf="project.image" [src]="project.image" alt=""/>
              </td>
              <td class="font-weight-bold">
                <div class="d-flex align-items-start">
                  <ng-container *ngIf="project.notes">
                    <button type="button" class="info-button position-absolute" [ngbPopover]="notesTemplate"
                            triggers="mouseenter:mouseleave" placement="auto" container="body"
                            [popoverClass]="'info-popover'">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    </button>

                    <ng-template #notesTemplate>{{project.notes}}</ng-template>
                  </ng-container>
                  <div>
                    <span class="cursor-pointer"
                          routerLink="/{{routes.campaigns({projectId: project.id})}}">{{project.title}}</span>
                    <span class="d-block client-container">
                  <small class="mr-1"
                         title="Project Status">{{getProjectStatus(project)}}</small>
                  <small>-</small>
                  <small class="mr-1 ml-1" title="Project Code">{{project.code}}</small>
                  <small>-</small>
                  <small title="Client Name" class="ml-1  cursor-pointer"
                         (click)='projectListByClient(project.client)'>{{project.client.name}}</small>
                  <ng-container *ngIf="project.client?.organization?.name">
                    <small> -</small>
                    <small title="Organization Name" class="ml-1">{{project.client.organization.name}}</small>
                  </ng-container>
                </span>
                  </div>
                </div>
              </td>
              <td routerLink="/{{routes.campaigns({projectId: project.id})}}" class="cursor-pointer">
                {{project.campaign_count}}
              </td>
              <td [ngClass]="{'d-none': !showAll}">{{project.total_influencer_count}}</td>
              <td [ngClass]="{'d-none': !showAll}">{{project.emailProgress?.opened}}/ <span class="click-rate">{{getOpenClickRate(project)}}%</span></td>
              <td [ngClass]="{'d-none': !showAll}">{{project.pageviews_count ? project.pageviews_count : '-'}}</td>
              <td [ngClass]="{'d-none': !showAll}">{{project.referrals_count}}/<span> {{getReferralsRatePercentage(project)}}%</span></td>
              <td class="d-none">{{project.created_at}}</td>
              <td>
                <button class="btn-icon float-right" mat-icon-button [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu">
                  <span class="fa fa-ellipsis-v"></span>
                </button>
                <mat-menu #menu="matMenu" class="campaign-popover">
                  <a class="dropdown-item d-flex align-items-center"
                     routerLink="/{{routes.createCampaign({projectId: project.id})}}">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                    Start a new campaign
                  </a>
                  <a class="dropdown-item d-flex align-items-center" [routerLink]="['/projects', project.id, 'edit']" sbEntityLink>
                    <i class="fa fa-pencil mr-2"></i>
                    Edit
                  </a>
                  <a class="dropdown-item d-flex align-items-center"
                     routerLink="/{{routes.campaigns({projectId: project.id})}}">
                    <i class="fa fa-list mr-2" aria-hidden="true"></i>
                    Manage Campaigns
                  </a>
                  <a class="dropdown-item d-flex align-items-center"
                     routerLink="/{{routes.statistics({projectId: project.id})}}">
                    <i class="fa fa-eye mr-2"></i>
                    View Results
                  </a>
                  <a class="dropdown-item d-flex align-items-center" (click)="copyProject(project.id)">
                    <i class="fa fa-clipboard mr-2"></i>
                    Duplicate
                  </a>
                  <a class="dropdown-item d-flex align-items-center" (click)="deleteProject(project.id)">
                    <i class="fa fa-trash mr-2"></i>
                    Delete
                  </a>
                </mat-menu>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!(loader$ | async) && viewType === 'card'">
            <tr *ngFor="let project of projects" class="project-card-view">
              <td class="font-weight-bold project-client-name">
                <div class="d-flex align-items-center justify-content-between project-client-details">
                  <div class="d-flex align-items-center project-client-name-details">
                    <div class="img-wrapper mr-3 cursor-pointer" [ngClass]="{'image-cover' : !project.image}">
                      <img class="image-thumbnail img-fluid" *ngIf="project.image" [src]="project.image" alt=""/>
                    </div>
                    <div class="name">
                      <ng-container *ngIf="project.notes">
                        <button type="button" class="info-button position-absolute" [ngbPopover]="notesTemplate"
                                triggers="mouseenter:mouseleave" placement="auto" container="body"
                                [popoverClass]="'info-popover'">
                          <i class="fa fa-file-text-o" aria-hidden="true"></i>
                        </button>

                        <ng-template #notesTemplate>{{project.notes}}</ng-template>
                      </ng-container>
                      <div class="project-name-details">
                        <span class="cursor-pointer"
                              routerLink="/{{routes.campaigns({projectId: project.id})}}">{{project.title}}</span>
                        <span class="d-block">
                        <small class="mr-1">{{getProjectStatus(project)}}</small>
                        <small>-</small>
                        <small class="mr-1 ml-1">{{project.code}}</small>
                        <small>-</small>
                        <small class="cursor-pointer ml-1"
                               (click)='projectListByClient(project.client)'>{{project.client.name}}</small>
                        <ng-container *ngIf="project.client?.organization?.name">
                          <small> -</small>
                          <small class="ml-1">{{project.client.organization.name}}</small>
                        </ng-container>
                      </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button class="btn-icon float-right" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                      <span class="fa fa-ellipsis-v"></span>
                    </button>
                    <mat-menu #menu="matMenu" class="campaign-popover">
                      <a class="dropdown-item d-flex align-items-center"
                         routerLink="/{{routes.createCampaign({projectId: project.id})}}">
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                        Start a new campaign
                      </a>
                      <a class="dropdown-item d-flex align-items-center" [routerLink]="['/projects', project.id, 'edit']" sbEntityLink>
                        <i class="fa fa-pencil mr-2"></i>
                        Edit
                      </a>
                      <a class="dropdown-item d-flex align-items-center"
                         routerLink="/{{routes.campaigns({projectId: project.id})}}">
                        <i class="fa fa-list mr-2" aria-hidden="true"></i>
                        Manage Campaigns
                      </a>
                      <a class="dropdown-item d-flex align-items-center"
                         routerLink="/{{routes.statistics({projectId: project.id})}}">
                        <i class="fa fa-eye mr-2"></i>
                        View Results
                      </a>
                      <a class="dropdown-item d-flex align-items-center" (click)="copyProject(project.id)">
                        <i class="fa fa-clipboard mr-2"></i>
                        Duplicate
                      </a>
                      <a class="dropdown-item d-flex align-items-center" (click)="deleteProject(project.id)">
                        <i class="fa fa-trash mr-2"></i>
                        Delete
                      </a>
                    </mat-menu>
                  </div>
                </div>
              </td>
              <td class="project-status">
                <div class="campaign" routerLink="/{{routes.campaigns({projectId: project.id})}}">
                  {{project.campaign_count}} campaigns
                </div>
                <div>
                  <div class="card-header--actions">
                    <button class="btn btn-primary btn-sm"
                            routerLink="/{{routes.createCampaign({projectId: project.id})}}">
                      <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
                      <span class="btn-wrapper--label">Start Campaign</span>
                    </button>
                  </div>
                </div>
              </td>
              <td  [ngClass]="{'d-none': !showAll && currentUser?.can( 'view-client-column', 'project-ui')}" class="project-social-details">
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white mr-3 text-center">
                      <li class="fa fa-users" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div
                        class="font-size-xxl font-weight-bold social-count">{{project.total_influencer_count}}</div>
                      <div class="pb-1 social-name">Influencers</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white mr-3 text-center">
                      <li class="fa fa-envelope" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div class="font-size-xxl font-weight-bold social-count">{{project.emailProgress?.opened}}/ <span
                        class="click-rate">{{getOpenClickRate(project)}}%</span></div>
                      <div class="pb-1 social-name">Open/Click Rate</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white mr-3 text-center">
                      <li class="fa fa-eye" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div
                        class="font-size-xxl font-weight-bold social-count">{{project.pageviews_count ? project.pageviews_count : '0'}}</div>
                      <div class="pb-1 social-name">Impressions</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white mr-3 text-center">
                      <li class="fa fa-usd" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div class="font-size-xxl font-weight-bold social-count">{{getReferralsRatePercentage(project)}}%
                      </div>
                      <div class="pb-1 social-name">Conversion</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
          <tbody *ngIf="projects?.length <= 0">
          <tr [ngClass]="{'no-data-card-view': viewType === 'card' && projects?.length <= 0}">
            <td colspan="9" class="no-data-available">No data available in table</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ng-container *ngIf="!(loader$ | async) && !allProjectList?.length && !errorMessage?.length && !isOnLoad">
      <div class="no-data">
        <div class="container h-100">
          <div class="row h-100 align-items-center">
            <div class="col-12">
              <div class="no-data-bg text-center">
                <div class="content">
                  <h3 class="title">
                    Welcome to Snöball!
                  </h3>
                  <div class="img-wrapper">
                    <img src="/assets/images/my-project-no-content.svg" class="img-fluid" alt="no-content-images">
                  </div>
                  <p class="details">
                    Snöball makes it easy to scale influencer marketing to grow your events. Mobilize your attendees,
                    speakers, sponsors and exhibitors to social-proof your event. We’ll help you get started.
                  </p>
                  <a *ngIf="currentUser?.can('create-project', 'project-ui')" href="#" class="new-project-btn" routerLink="/{{routes.createProject()}}" sbEntityLink>
                    <i class="fa fa-plus"></i>
                    Start a new project
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
</app-page-shell>

<!-- Body of the delete confirmation (SbModalService). It names the people who decide
     before the user commits, so nobody confirms a deletion without knowing who approves it. -->
<ng-template #deleteProjectTpl>
  <!-- Still running: the server refuses both request types until the activity end date
       has passed, so the dialog explains that and offers no choice. Opened with a single
       Close button (see confirmDeleteProject), so there is nothing here to continue to. -->
  <ng-container *ngIf="deleteConfirm?.isActive">
    <p>
      This project <b>cannot be deleted or anonymized yet</b>.
      <ng-container *ngIf="deleteConfirm.endsAt; else noEndDate">Its activity end date is
        <b>{{ deleteConfirm.endsAt | date:'longDate' }}</b>, which is still ahead.</ng-container>
      <ng-template #noEndDate>It has <b>no activity end date</b>, so it counts as still
        active.</ng-template>
    </p>
    <p class="mb-0 text-muted">
      To remove it, first update the project's <b>activity end date</b> to a date that has
      passed, then come back here. A project is judged finished from the day after that date.
    </p>
  </ng-container>

  <ng-container *ngIf="deleteConfirm && !deleteConfirm.isActive">
    <!-- Anonymize first and selected by default: the choice that keeps the project and its
         reports. Deleting permanently is always picked on purpose. -->
    <div class="dp-type-choice mb-3">
      <div class="custom-control custom-radio mb-2">
        <input type="radio" id="dp-type-anonymize" name="dp-type" class="custom-control-input"
               [value]="'anonymize'" [(ngModel)]="deleteConfirm.type" [ngModelOptions]="{standalone: true}"
               [disabled]="deleteConfirm.isAnonymized">
        <label class="custom-control-label" for="dp-type-anonymize">
          <b>Anonymize</b> ({{ anonymizeSummary }})
          <span class="d-block text-muted small" *ngIf="deleteConfirm.isAnonymized">
            Already anonymized, so it can only be deleted now.
          </span>
        </label>
      </div>
      <app-anonymize-scope-choice *ngIf="deleteConfirm.type === 'anonymize' && !deleteConfirm.isAnonymized"
                                  class="pl-4 mb-2" idPrefix="dp-delete-scope" [(value)]="deleteConfirm.scope">
      </app-anonymize-scope-choice>
      <div class="custom-control custom-radio">
        <input type="radio" id="dp-type-delete" name="dp-type" class="custom-control-input"
               [value]="'delete'" [(ngModel)]="deleteConfirm.type" [ngModelOptions]="{standalone: true}">
        <label class="custom-control-label" for="dp-type-delete">
          <b>Delete</b> &mdash; permanently deletes the project and everything in it once
          approved. It cannot be recovered.
        </label>
      </div>
    </div>

    <p *ngIf="deleteConfirm.type === 'delete'">
      The project will be <b>hidden immediately</b>, along with its contacts, campaigns and
      reports, and a deletion request will be created. Once approved, it is
      <b>permanently deleted and cannot be recovered</b>.
    </p>
    <p *ngIf="deleteConfirm.type === 'anonymize'">
      The project is <b>hidden immediately</b> and an anonymization request will be created.
      Once approved it <b>comes back</b> under its own name, with what is ticked above cleared.
      What is cleared cannot be brought back.
    </p>
    <p class="small text-warning" *ngIf="deleteConfirm.evidenceWarnings[deleteConfirm.type]">{{ deleteConfirm.evidenceWarnings[deleteConfirm.type] }}</p>
    <!-- Three cases, and the dialog must never promise an email in the third: this
         environment may send no data-protection mail at all, in which case the request is
         reviewed on the dashboard and nobody is written to. -->
    <ng-container *ngIf="deleteConfirm.emailsEnabled; else noEmails">
      <ng-container *ngIf="deleteConfirm.approvers.length; else noApprovers">
        <p class="mb-1">An approval email will be sent to:</p>
        <ul class="pl-4 mb-3">
          <li *ngFor="let approver of deleteConfirm.approvers" class="mb-1">
            <div class="font-weight-bold">{{ approver.name }}</div>
            <div class="small text-muted">{{ approver.email }}</div>
          </li>
        </ul>
      </ng-container>
      <ng-template #noApprovers>
        <p class="text-muted">
          <i>This client has no account managers, so no approval email can be sent. The request
            will still be created and an administrator can approve it under
            <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
        </p>
      </ng-template>
    </ng-container>
    <ng-template #noEmails>
      <p class="text-muted">
        <i>No approval email is sent for data protection requests here. The request will be
          created and reviewed under
          <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
      </p>
    </ng-template>
    <p class="text-danger" *ngIf="deleteConfirm.warning">{{ deleteConfirm.warning }}</p>
    <p class="text-muted" *ngIf="deleteConfirm.emailsEnabled && deleteConfirm.creatorName">
      <i>{{ deleteConfirm.creatorName }} created this project and will be notified.</i>
    </p>
    <p class="mb-0">
      It can be approved<ng-container *ngIf="deleteConfirm.emailsEnabled"> from that email
        or</ng-container> under
      <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>, and cancelled
      there until the work on it starts<ng-container *ngIf="deleteConfirm.type === 'delete'">, which
        restores the project</ng-container>.
    </p>
  </ng-container>

  <!-- Where approvals live. Someone who can open that page is told the way to it and given
       the link (a new tab, so this dialog and the list stay put); anyone else just hears
       the page's name. -->
  <ng-template #dataProtectionRef>
    <ng-container *ngIf="currentUser?.can('view', 'data-protection-ui'); else dataProtectionName">
      <a [href]="'/' + routes.dataProtection()" target="_blank" rel="noopener">Admin Menu &rarr; Data Protection</a>
    </ng-container>
    <ng-template #dataProtectionName>the Data Protection dashboard</ng-template>
  </ng-template>
</ng-template>

